import React from 'react';
import { Neo } from '@singularsystems/neo-react';
import { Catalogue } from '@singularsystems/neo-react-services';
import { observer } from 'mobx-react';
import { CatalogueRoutes } from "../Routes/CatalogueRoutes";
import { TextConstants } from '../../../Common/TextConstants';
import { Misc } from '@singularsystems/neo-core';
import { Types } from '../../StaticData/StaticDataTypes';
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles";

@observer
export default class CatalogueView extends Catalogue.CatalogueViewBase {
    public authorisationService = Misc.Globals.appService.get(Types.Neo.Security.AuthorisationService);

    constructor(props: unknown) {
        super(
            "System Configuration",
            props,
            CatalogueRoutes);
    }

    public static getRouteChildren() {
        return this.getViewRoutes(CatalogueRoutes);
    }

    protected renderMenu() {
        return (
            <Neo.GridLayout lg={2}>
                <Neo.Card title={TextConstants.Titles.SystemConfiguration}>
                    {this.renderSection(CatalogueRoutes.systemConfiguration)}
                </Neo.Card>
                {this.authorisationService.hasRole(Roles.OrganisationConfigurationsRoles.View) &&
                    <Neo.Card title={TextConstants.Titles.OrganisationConfiguration}>
                        {this.renderSection(CatalogueRoutes.organisationConfiguration)}
                    </Neo.Card>
                }
            </Neo.GridLayout>
        );
    }
}